import script from "./ApertureSourceEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./ApertureSourceEditor.vue?vue&type=script&setup=true&lang=js"

import "./ApertureSourceEditor.vue?vue&type=style&index=0&id=e1a7bd04&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e1a7bd04"]])

export default __exports__